/* eslint-disable */

const customAuth = {
  // https://docs.amplify.aws/lib/client-configuration/configuring-amplify-categories/q/platform/js/#scoped-configuration
  authenticationFlowType: "CUSTOM_AUTH",
};

export default customAuth;
